import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}.json',
      // The locale files keep their names across deploys; a cached copy
      // without new keys shows the raw keys.
      queryStringParams: { v: __BUILD_ID__ },
    },
  })

export default i18n
